export default __webpack_public_path__ + "static/media/add2.38dcbdd0.png";